<template>
  <div>
    <WdsStack v-if="projectTracking">
      <WdsText primary>
        {{ $t('Associated project') }}:&nbsp;{{ project?.name ?? $t('None') }}
      </WdsText>
      &nbsp;
      <a v-if="editPath !== null" :href="editPath">{{ $t('Change') }}</a>
    </WdsStack>
    <ProgressBar :label="$t('Job budget')" :currency="currency" :spent="spent" :budget="budget" />
  </div>
</template>

<script setup>
import { WdsStack, WdsText } from '@worksome/wds-components'
import ProgressBar from '@/components/Projects/ProgressBar.vue'

defineProps({
  editPath: {
    type: String,
    default: null,
  },
  project: {
    type: Object,
    default: () => ({}),
  },
  currency: {
    type: String,
    default: null,
  },
  spent: {
    type: Number,
    default: null,
  },
  budget: {
    type: Number,
    default: null,
  },
  projectTracking: {
    type: Boolean,
    default: false,
  },
})
</script>
